import React, { useState } from 'react';
import { Button } from './ui/Button';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../lib/i18n';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const availableLanguages = Object.values(SUPPORTED_LANGUAGES);

  const handleLanguageChange = (languageCode) => {
    i18n.changeLanguage(languageCode);
    setIsOpen(false);
  };

  const currentLang = SUPPORTED_LANGUAGES[i18n.language] || SUPPORTED_LANGUAGES.en;

  return (
    <div className="relative">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 font-medium text-slate-500 hover:text-slate-900"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
        </svg>
        <span>{currentLang.nativeName}</span>
        <svg className={`w-3 h-3 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </Button>

      {isOpen && (
        <div className="absolute right-0 z-50 mt-2 w-48 bg-white rounded-lg shadow-xl border border-slate-100 overflow-hidden animate-in fade-in slide-in-from-top-1">
          <div className="py-1">
            <div className="px-3 py-2 text-xs font-semibold text-slate-500 bg-slate-50">
              Select Language
            </div>
            <div>
              {availableLanguages.map((language) => (
                <Button
                  variant="ghost"
                  key={language.code}
                  onClick={() => handleLanguageChange(language.code)}
                  className={`w-full justify-start px-4 py-3 text-sm font-normal rounded-none h-auto ${i18n.language === language.code
                      ? 'text-slate-900 bg-slate-50 font-medium'
                      : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                    }`}
                >
                  <span className="mr-2">{language.flag}</span>
                  <span>{language.nativeName}</span>
                </Button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;